export interface HelpContent {
  name: string;
  type: string;
  helpText: string;
  icon: string;
  enabled: boolean;
}

export const PersonaHelpContent = [
  {
    name: 'Service Line',
    type: 'Property',
    helpText:
      'Covers damage to and repair of exterior underground piping and wiring providing one of the following services to your residence: cable or data transmission, compressed air, drainage, electrical power, heating, waste disposal, or water.',
    icon: 'truck.svg',
    enabled: true,
  },
  {
    name: 'Valuables Plus',
    type: 'Property',
    helpText:
      'Valuables Plus is an additional coverage separate from the base home policy, providing broad coverage for customers who require additional protection beyond the base homeowner policy for specifically defined personal property types, such as jewelry.',
    icon: 'piggybank-outline.svg',
    enabled: true,
  },
  {
    name: 'Equipment Breakdown',
    type: 'Property',
    helpText:
      'Covers damage to and repair of exterior underground piping and wiring providing one of the following services to your residence: cable or data transmission, compressed air, drainage, electrical power, heating, waste disposal, or water.',
    icon: 'truck.svg',
    enabled: true,
  },
  {
    name: 'Smart home',
    type: 'Property',
    helpText:
      "It can alert customers of potential issues, like water leaks, fires or break-ins, before they become big problems. They'll receive an email with all the details, including a link to Nationwide's smart home partner. To participate, they'll need: <p><br>A smart home monitoring system <br>A mobile device, wi-fi and the monitoring system's app <br>To install and activate the system within 55 days of enrolling</p>",
    icon: 'wi-fi.svg',
    enabled: true,
  },
  {
    name: 'Water backup',
    type: 'Property',
    helpText:
      'Protects you against losses caused by water that backed up through sewers or drains, or overflows a sump pump, sump pump well, or other system designed to remove water from the foundation area. This is not flood insurance.',
    icon: 'shield',
    enabled: true,
  },
  {
    name: 'Brand New Belongings',
    type: 'Property',
    helpText:
      'Pays the full cost to replace or repair covered personal property, whichever costs less, without a deduction for depreciation. This coverage may also be referred to as Personal Property Replacement Cost. If replacement cost is provided in lieu of the cost to repair, this covers the cost, at the time of the loss, of a new item identical to the one damaged or stolen. When an identical item is no longer available, we cover the cost of a new item similar to the one covered in the loss. For example, with this coverage, if you purchased a TV five years ago for $500, you could be paid the current market value of an equivalent TV today. However, without replacement coverage, you would be paid the depreciated amount for the TV, which may only be $50. Any special limits of liability in the policy will apply to this coverage.',
    icon: 'shield',
    enabled: true,
  },
  {
    name: 'Roadside Assistance',
    type: 'Auto',
    helpText:
      'Roadside Assistance provides limited reimbursement for 24/7 emergency help if you need fuel delivery, a tire change, jumpstart or tow (or use our Roadside Assistance Representative). The Plus option adds trip interruption (food, lodging, transport assistance for covered losses more than 100 miles from home), and increased roadside assistance reimbursement. See endorsement for details, limits and exclusions.',
    icon: 'tow-truck.svg',
    enabled: true,
  },
  {
    name: 'Identity Theft',
    type: 'More',
    helpText:
      'This endorsement provides limited coverage to pay for expenses incurred by an insured as a direct result of any single identity theft or fraud first discovered or learned of during the policy period.',
    icon: 'idcard.svg',
    enabled: true,
  },
];
